import { prettifyBytes } from "helpers/commonHelpers";
import CommentItem from "components/common/CommentItem/CommentItem";
import { DateTimeFormat, formatInPreferredTimezone } from "helpers/dateTimeHelper";
import Delivered from "./Delivered";
import { ActivityItemProps } from "./ActivityItemTypes";

/**
 * Gets the uploaded files of the message
 * @param data the uploaded data of the message
 * @returns array of files
 */
const extractFilesFromData = (
  data: any,
): {
  url: string;
  name: string;
  size?: string;
  isLoading?: boolean;
}[] => {
  if (!data || !Array.isArray(data)) return [];
  const files: any = [];
  let currentFile: any = {};
  data.forEach((item: any) => {
    if (item.key === "attachment_url") {
      if (item.value) currentFile.url = item.value;
      // For default files, see useGetDefaultFiles.ts
      else {
        currentFile.onClick = item.onClick;
        currentFile.isLoading = item.isLoading;
      }
    } else if (item.key === "attachment_name") {
      if (currentFile) {
        const parts = item.value.split("/");
        currentFile.name = parts[parts.length - 1]; // Extract the filename from the path
      }
    } else if (item.key === "attachment_size") {
      if (currentFile && !isNaN(Number(item.value))) {
        currentFile.size = prettifyBytes(item.value); // Extract the size
      }
      files.push(currentFile);
      currentFile = {};
    }
  });
  return files;
};

export default function ActivityItem({
  message,
  type,
  company,
  author_name,
  timestamp,
  data,
  deleted_attachments,
  is_user_comment,
  tracking_key,
  filesExtractedFromMessages,
}: ActivityItemProps) {
  const files = extractFilesFromData(data);
  const filesExtractedFromMessagesByTrackingKey = filesExtractedFromMessages
    ?.find((item) => item.tracking_key === tracking_key)
    ?.links?.map((link) => ({
      name: link.name,
      url: link.url,
    }));
  const filesWithFilesFromMessage = [...files, ...(filesExtractedFromMessagesByTrackingKey || [])];
  const isDeliveredUpdate = type === "delivered" && !message;

  return (
    <CommentItem
      authorName={author_name}
      logo={company?.company_logo}
      companyName={company?.company_name}
      customMessage={isDeliveredUpdate && <Delivered />}
      timestamp={timestamp ? formatInPreferredTimezone(timestamp, DateTimeFormat.fullDateTimeFormat) : undefined}
      message={message}
      files={filesWithFilesFromMessage}
      deletedAttachments={deleted_attachments}
      isUserComment={is_user_comment}
    />
  );
}

ActivityItem.defaultProps = {
  message: undefined,
  author_name: undefined,
  timestamp: undefined,
  data: [],
  deleted_attachments: null,
  filesExtractedFromMessages: undefined,
};
